// @flow

import {Tag} from 'docs/util';
import type {MarkdocTagRegistration} from 'docs/markdoc';

// Extract the raw code inside of the markdoc-example tag.
const getExampleCodeFromText = (node, lines) => {
  const CLOSING_TAG_REGEX = /{% \/markdoc-example %}/;

  // node.lines[0] will correspond to the line that contains the
  // {% markdoc-example %} tag. node.lines[1] corresponds to the end
  // of the opening {% markdoc-example %} tag.
  const lineStart = node.lines[0] + 1;
  let lineEnd;

  for (let i = node.lines[0]; i < lines.length; i++) {
    if (lines[i].match(CLOSING_TAG_REGEX) != null) {
      lineEnd = i;
      break;
    }
  }

  return lines
    .slice(lineStart, lineEnd)
    .join('\n')
    .trim();
};

export const MarkdocExample: MarkdocTagRegistration = {
  tag: 'markdoc-example',
  component: 'MarkdocExample',
  attributes: {
    hidePreview: {type: Boolean, required: false},
  },
  render(node, config) {
    let rawText = config.text;
    const partialFileName = config.variables['$$partial:filename'];
    if (typeof partialFileName === 'string') {
      rawText = config.partials[partialFileName].text;
    }
    const lines = rawText ? rawText.split('\n') : [];
    const exampleCode = getExampleCodeFromText(node, lines);
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    return new Tag(this.tag, {...attributes, exampleCode}, children);
  },
};
